<template>
  <header class="relative text-white mx-4 lg:mx-6 xl:mx-12 pt-5 sm:pt-10 md:pt-12 lg:pt-16 xl:pt-24 2xl:pt-32" data-component="LidHeader">
    <div class="bg-header-content flex md:grid grid-cols-12 sm:gap-5 lg:gap-8 mx-auto px-5 sm:px-12 md:px-0">
      <div class="col-span-full md:col-span-10 md:col-start-2 xl:col-span-8 xl:col-start-2">
        <time v-if="date" class="block whitespace-nowrap text-sm leading-none mb-2 sm:mb-5 md:mb-6 lg:mb-8 xl:mb-12 2xl:mb-16 md:text-lg lg:text-xl xl:text-2xl">
          {{ $d(new Date(date), 'medium-date') }}
        </time>
        <h1 class="text-detail-page-title mb-5 sm:mb-10 md:mb-12 xl:mb-20 2xl:mb-32">
          {{ title }}
        </h1>
      </div>
    </div>
    <div v-if="image" class="header-picture md:grid grid-cols-12 sm:gap-5 lg:gap-8 mx-auto relative px-5 sm:px-12 md:px-0">
      <MoleculePicture :image="image" :alt="title" class="col-span-full md:col-span-10 md:col-start-2 relative z-10 block rounded-xl overflow-hidden" />
    </div>
  </header>
</template>

<script setup lang="ts">
interface Props {
  date?: string
  title?: string
  subtitle?: string
  image?: object
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.bg-header-content {
  $ratio: calc(1088px / 612px);
  $width-xs: calc(100vw - 1rem - 1rem - 1.25rem - 1.25rem);
  $height-xs: calc(100% - (#{$width-xs} / #{$ratio} / 2));
  $width-sm: calc(100vw - 1rem - 1rem - 3rem - 3rem);
  $height-sm: calc(100% - (#{$width-sm} / #{$ratio} / 2));
  $column-width-md: calc((100vw - 1rem - 1rem - (32px * 11)) / 12);
  $width-md: calc((#{$column-width-md} * 10) + (9 * 32px));
  $height-md: calc(100% - (#{$width-md} / #{$ratio} / 2));
  $column-width-xl: calc((100vw - 3rem - 3rem - (32px * 11)) / 12);
  $width-xl: calc((#{$column-width-xl} * 10) + (9 * 32px));
  $height-xl: calc(100% - (#{$width-xl} / #{$ratio} / 2));

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: $height-xs;
    background-color: #002c54;
    top: 0;
    left: 0;
    border-radius: 12px;
    z-index: -1;
    background-image: url('/images/LID/paw.svg');
    background-size: 300px;
    background-repeat: no-repeat;
    background-position: top 20px right -110px;

    @screen sm {
      height: $height-sm;
      background-position: top 30px right -110px;
    }

    @screen md {
      height: $height-md;
      background-size: 340px;
      background-position: top 30px right -120px;
    }

    @screen lg {
      background-size: 410px;
      background-position: top 50px right -140px;
    }

    @screen xl {
      height: $height-xl;
      background-size: 580px;
      background-position: top 50px right -210px;
    }

    @screen 2xl {
      background-size: 727px;
      background-position: top 70px right -260px;
    }
  }
}
</style>
